export default __webpack_public_path__ + "static/media/header.ec9c5c6f.png";